import {
  Activity,
  BarChart3,
  Bot,
  Building2,
  Download,
  FileText,
  Flag,
  Globe,
  Home,
  Library,
  Mail,
  Package,
  Receipt,
  Star,
  Ticket,
  Users,
  UserPen,
  Wallet,
  type LucideIcon,
  Layers,
} from 'lucide-react';

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
}

export interface NavSection {
  /** Optional uppercase heading. Omit for the top section. */
  label?: string;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  {
    items: [{ label: 'Home', to: '/', icon: Home }],
  },
  {
    label: 'Platform',
    items: [
      { label: 'Companies', to: '/companies', icon: Building2 },
      { label: 'Users', to: '/users', icon: Users },
      { label: 'Regions', to: '/regions', icon: Globe },
    ],
  },
  {
    label: 'Content',
    items: [
      { label: 'Catalogues', to: '/catalogues', icon: Library },
      { label: 'Featured songs', to: '/featured-songs', icon: Star },
      { label: 'Flagged songs', to: '/flagged-songs', icon: Flag },
      { label: 'AI songs', to: '/ai-songs', icon: Bot },
      { label: 'Creators', to: '/creators', icon: UserPen },
    ],
  },
  {
    label: 'Finance',
    items: [
      { label: 'Tiers', to: '/tiers', icon: Layers },
      { label: 'Credits', to: '/credits', icon: Wallet },
      { label: 'Credit packages', to: '/credit-packages', icon: Package },
      { label: 'Promo codes', to: '/promo-codes', icon: Ticket },
      { label: 'Financials', to: '/financials', icon: Receipt },
      { label: 'VAT', to: '/vat', icon: FileText },
    ],
  },
  {
    label: 'System',
    items: [
      { label: 'Analytics', to: '/analytics', icon: Activity },
      { label: 'Search stats', to: '/search-stats', icon: BarChart3 },
      { label: 'Imports', to: '/imports', icon: Download },
      { label: 'Contact messages', to: '/contact-messages', icon: Mail },
    ],
  },
];

/** Flat list — used by Breadcrumbs to resolve the route-level default crumb. */
export const NAV_ITEMS: NavItem[] = NAV_SECTIONS.flatMap((s) => s.items);
